import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import {
    addListItem, changeListItem, deleteListItem, getListFromValues,
    hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'
import { doGetEducationalMaterials, doSaveEducationalMaterials, doDeleteEducationalMaterials } from '../../reducers/actions'

class EducationalMaterialsDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.doGetEducationalMaterials()
    }

    doGetEducationalMaterials = () => {
        const { dispatch, id, personID } = this.props
        dispatch(doGetEducationalMaterials({
            id: id || 0,
            personID: personID || 0,
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, personID, initValues基本信息, changedValues基本信息: {} })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onClose, onRefresh, id, personID } = this.props
        const { initValues基本信息, changedValues基本信息, } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        dispatch(doSaveEducationalMaterials({
            id: id || 0,
            personID: personID || 0,
            changedValues基本信息,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onRefresh && onRefresh()
                    onClose && onClose()
                }
            }
        }))
    }

    handlerDelete = () => {
        const { dispatch, onClose, onRefresh } = this.props
        const { id } = this.state

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteEducationalMaterials({
                id: id || 0,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return this.bChanged() && values.学历 && values.学校名称中文
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '学历', minWidth: '50%', required: true },
            { _text: '学校名称（中文）', name: '学校名称中文', minWidth: '50%', required: true, },
            { _text: '学校名称（英文）', name: '学校名称英文', minWidth: '95%', },
            { _text: '毕业科系', minWidth: '50%' },
            { _select: '毕/结业', name: '毕结业', minWidth: '50%', options: ['毕业', '结业'] },
            { _date: '入学日期', minWidth: '50%', },
            { _date: '离校日期', minWidth: '50%', },
            { _files: '附件', minWidth: '95%', },
            { _text: '备注', minWidth: '95%', maxRows: 3 },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state

        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth="1000"
            controls={
                bReadOnly && [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] ||
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(EducationalMaterialsDiv)